const reExpPart = /experiments:([^,]+)/;
const reExperiments = /([\w-]+)=([\w-]+)/g;
const rePlacement = /^placement:([^,]+)$/;
const reBasePath = /^basePath:([^,]+)$/;
const reContentfulEnv = /^cfenv:([^,]+)$/;

/**
 * Parse experiments from split param and formats to a hivemind object
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {object} experiment
 */
function splitExperiments(splits) {
  const hasExperiments = splits.find(part => reExpPart.test(part));

  if (hasExperiments) {
    const [, splitMatch] = hasExperiments.match(reExpPart);
    return [...splitMatch.matchAll(reExperiments)]
      .reduce((acc, match) => {
        const [, experimentId, cohortId] = match;
        acc[experimentId] = { cohortId };
        return acc;
      }, {});
  }
  return {};
}

/**
 * Inspects splits to determine if the Preview API should be used or not
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {boolean} preview
 */
function splitPreview(splits) {
  return Boolean(splits.find(part => part === 'preview'));
}

/**
 * Inspects splits to determine if the Contentful Environment should be used or not
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {string} cfenv
 */
function splitContentfulEnv(splits) {
  const hasContentfulEnv = splits.find(part => reContentfulEnv.test(part));

  if (hasContentfulEnv) {
    const [, splitMatch] = hasContentfulEnv.match(reContentfulEnv);
    return splitMatch;
  }
  return;
}

/**
 * Parse placement from split param
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {object} placement
 */
function splitPlacement(splits) {
  const hasPlacement = splits.find(part => rePlacement.test(part));

  if (hasPlacement) {
    const [, splitMatch] = hasPlacement.match(rePlacement);
    return splitMatch;
  }
  return null;
}

/**
 * Parse base path from split param
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {object} basepath
 */
function splitBasePath(splits) {
  const hasBasePath = splits.find(part => reBasePath.test(part));

  if (hasBasePath) {
    const [, splitMatch] = hasBasePath.match(reBasePath);
    return splitMatch;
  }
  return null;
}

/**
 * Uses splits to determine if the "header-cart" string is present or not
 *
 * @param {string[]} splits - Array of string values parsed from split param
 * @returns {boolean} Flag indicating if the header cart is present
 */
function splitHeaderCart(splits) {
  return Boolean(splits.find(part => part === 'header-cart'));
}

export {
  splitExperiments,
  splitPreview,
  splitPlacement,
  splitContentfulEnv,
  splitBasePath,
  splitHeaderCart
};
